// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"2cd423cf","126":"b7ca7596","306":"cfabffa8","315":"f7fbd024","494":"7f3f8383","555":"e93dcaf7","599":"7100b944","617":"71100204","638":"ada53b4e","722":"1023d441","969":"a1177749"}[chunkId] + ".chunk.js";
};